import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { DateVectorRange } from '../utils/DateVectorRange';
import { extractDataFromDOMEvent } from '../utils/extractDataFromDOMEvent';
export var useDateRangePickerSelectionEvents = function useDateRangePickerSelectionEvents(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectionStartCandidate = _useState2[0],
      setSelectionStartCandidate = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionEndCandidate = _useState4[0],
      setSelectionEndCandidate = _useState4[1];

  var onClick = useCallback(function (event) {
    var data = extractDataFromDOMEvent(event);

    if (!data || !data.displayedMonth) {
      return;
    }

    var vector = data.vector,
        withShift = data.withShift;
    var dateStart = value.dateStart,
        dateEnd = value.dateEnd;

    if (withShift) {
      if (vector.isGreaterThan(dateStart)) {
        onChange(value.clone({
          dateStart: dateStart,
          dateEnd: vector
        }));
      } else {
        onChange(value.clone({
          dateStart: vector,
          dateEnd: dateEnd
        }));
      }
    } else {
      onChange(value.clone({
        dateStart: vector,
        dateEnd: vector
      }));
    }
  }, [value, onChange]);
  var onMouseDown = useCallback(function (event) {
    var data = extractDataFromDOMEvent(event);

    if (!data || !data.displayedMonth) {
      return;
    }

    var vector = data.vector,
        withShift = data.withShift;
    var dateStart = value.dateStart,
        dateEnd = value.dateEnd;

    if (withShift) {
      if (vector.isGreaterThan(dateStart)) {
        setSelectionStartCandidate(dateStart);
      } else {
        setSelectionStartCandidate(dateEnd);
      }
    } else {
      setSelectionStartCandidate(vector.clone());
    }
  }, [value, setSelectionStartCandidate]);
  var onMouseEnter = useCallback(function (event) {
    var data = extractDataFromDOMEvent(event);

    if (!data || !data.displayedMonth) {
      return;
    }

    if (selectionStartCandidate) {
      setSelectionEndCandidate(data.vector);
    }
  }, [selectionStartCandidate, setSelectionEndCandidate]);
  useEffect(function () {
    var discardSelection = function discardSelection() {
      if (selectionStartCandidate && selectionEndCandidate) {
        var newSelection = [selectionStartCandidate, selectionEndCandidate];

        if (selectionEndCandidate.isSmallerThan(selectionStartCandidate)) {
          newSelection = [selectionEndCandidate, selectionStartCandidate];
        }

        onChange(new DateVectorRange(newSelection[0], newSelection[1]));
      }

      setSelectionStartCandidate(null);
      setSelectionEndCandidate(null);
    };

    document.addEventListener('mouseup', discardSelection);
    return function () {
      document.removeEventListener('mouseup', discardSelection);
    };
  }, [selectionStartCandidate, selectionEndCandidate, onChange]);
  return {
    dayButtonProps: {
      onClick: onClick,
      onMouseDown: onMouseDown,
      onMouseEnter: onMouseEnter
    },
    selectionStartCandidate: selectionStartCandidate,
    selectionEndCandidate: selectionEndCandidate
  };
};